import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import DebugPanel from "./DebugPanel";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-stone-50 print:block print:h-auto print:overflow-visible">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-stone-900/60 backdrop-blur-sm lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-30 w-sidebar flex-shrink-0
          transform transition-transform duration-300 ease-in-out
          lg:relative lg:translate-x-0
          print:hidden
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </aside>

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden print:block print:h-auto print:overflow-visible">
        {/* Mobile menu trigger */}
        <button
          className="fixed top-3 left-3 z-10 p-2 rounded-lg text-stone-500 bg-white shadow-sm border border-stone-200 hover:bg-stone-100 lg:hidden print:hidden"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open navigation"
        >
          <Bars3Icon className="w-5 h-5" />
        </button>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto scrollbar-thin print:overflow-visible print:h-auto">
          <Outlet />
          <DebugPanel />
        </main>

        {/* Footer logo */}
        <footer className="flex items-center justify-center py-3 bg-stone-50 border-t border-stone-100 flex-shrink-0 print:hidden">
          <img src="/ch-logo-green.png" alt="Camp Highlands" className="h-8 w-auto opacity-70" />
        </footer>
      </div>
    </div>
  );
}
